import React from "react";
import { Table } from "antd";

const InvoicesTab = ({ data }) => {
  return (
    <Table
      dataSource={data}
      rowKey={(r) => r.id}
      pagination={false}
      columns={[
        { title: "Invoice No", dataIndex: "id" },
        { title: "Amount", dataIndex: "amount" },
        { title: "Status", dataIndex: "status" },
        {
          title: "Date",
          dataIndex: "created_at",
          render: (v) => new Date(v).toLocaleString(),
        },
      ]}
    />
  );
};

export default InvoicesTab;
